module.exports = __webpack_public_path__ + "assets/img/yes.b6400fb5.png";